import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { CONTACT_PAGE_PATH } from "utils/constants/paths";

const ContactPage = Loadable(React.lazy(() => import("./View")));

export const ContactPageRoute: IRouteItem = {
  path: CONTACT_PAGE_PATH,
  element: React.createElement(ContactPage),
  name: "Contact",
};
